var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_291)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_74_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99805 9.6333V4.1333C3.99805 3.58102 4.44576 3.1333 4.99805 3.1333H30.498C31.0503 3.1333 31.498 3.58102 31.498 4.1333V9.6333",
    stroke: "#242529",
    strokeWidth: 3.76833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99805 24.8652V34.4101C3.99805 35.1779 4.82754 35.6593 5.4942 35.2783L17.5019 28.4166C17.8093 28.2409 18.1868 28.2409 18.4942 28.4166L30.5019 35.2783C31.1686 35.6593 31.998 35.1779 31.998 34.4101V24.8935",
    stroke: "#242529",
    strokeWidth: 3.76833,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54699 13.9271C3.84634 13.0057 5.14975 13.0057 5.4491 13.9271L5.73287 14.8004C5.86675 15.2124 6.2507 15.4914 6.68393 15.4914H7.60223C8.57095 15.4914 8.97373 16.731 8.19002 17.3004L7.44709 17.8402C7.09661 18.0948 6.94995 18.5462 7.08382 18.9582L7.36759 19.8316C7.66695 20.7529 6.61247 21.519 5.82875 20.9496L5.08583 20.4098C4.73535 20.1552 4.26075 20.1552 3.91026 20.4098L3.16734 20.9496C2.38363 21.519 1.32915 20.7529 1.6285 19.8316L1.91227 18.9582C2.04614 18.5462 1.89949 18.0948 1.549 17.8402L0.806079 17.3004C0.0223648 16.731 0.42514 15.4914 1.39386 15.4914H2.31216C2.74539 15.4914 3.12935 15.2124 3.26322 14.8004L3.54699 13.9271Z",
    fill: "#242529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9122 13.9271C17.2116 13.0057 18.515 13.0057 18.8143 13.9271L19.0981 14.8004C19.232 15.2124 19.6159 15.4914 20.0492 15.4914H20.9675C21.9362 15.4914 22.339 16.731 21.5553 17.3004L20.8123 17.8402C20.4618 18.0948 20.3152 18.5462 20.4491 18.9582L20.7328 19.8316C21.0322 20.7529 19.9777 21.519 19.194 20.9496L18.4511 20.4098C18.1006 20.1552 17.626 20.1552 17.2755 20.4098L16.5326 20.9496C15.7489 21.519 14.6944 20.7529 14.9937 19.8316L15.2775 18.9582C15.4114 18.5462 15.2647 18.0948 14.9142 17.8402L14.1713 17.3004C13.3876 16.731 13.7904 15.4914 14.7591 15.4914H15.6774C16.1106 15.4914 16.4946 15.2124 16.6285 14.8004L16.9122 13.9271Z",
    fill: "#242529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2814 13.9271C30.5807 13.0057 31.8841 13.0057 32.1835 13.9271L32.4672 14.8004C32.6011 15.2124 32.9851 15.4914 33.4183 15.4914H34.3366C35.3053 15.4914 35.7081 16.731 34.9244 17.3004L34.1815 17.8402C33.831 18.0948 33.6843 18.5462 33.8182 18.9582L34.102 19.8316C34.4013 20.7529 33.3468 21.519 32.5631 20.9496L31.8202 20.4098C31.4697 20.1552 30.9951 20.1552 30.6446 20.4098L29.9017 20.9496C29.118 21.519 28.0635 20.7529 28.3629 19.8316L28.6466 18.9582C28.7805 18.5462 28.6339 18.0948 28.2834 17.8402L27.5405 17.3004C26.7567 16.731 27.1595 15.4914 28.1282 15.4914H29.0465C29.4798 15.4914 29.8637 15.2124 29.9976 14.8004L30.2814 13.9271Z",
    fill: "#242529"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_74_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionsB);
export default __webpack_public_path__ + "static/media/Collections_b.2550ad3f955a97a000b5043706b3aef3.svg";
export { ForwardRef as ReactComponent };